module.exports = __webpack_public_path__ + "img/b1_jidibingfeng.920a7fcd.jpg";